// src/services/api.js
// Central axios instance — all pages import from here
import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:8000/api/v1',
  headers: { 'Content-Type': 'application/json' },
});

// Attach JWT token from localStorage on every request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('access_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Auto-refresh or redirect on 401
api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.clear();
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export default api;

// ── Convenience helpers ────────────────────────────────────────────────────
// Unwrap DRF paginated { count, results } or envelope { data }
export function unwrap(response) {
  // Always guarantee an array for list endpoints
  const d = response.data;
  if (d?.results !== undefined) return d.results;
  if (d?.data !== undefined) return d.data;
  return d;
}

// Format KES — full number with commas
export function formatKES(amount) {
  if (amount == null) return 'KES 0';
  return 'KES ' + Number(amount).toLocaleString('en-KE', { maximumFractionDigits: 0 });
}

// Format date string to readable
export function fmtDate(d) {
  if (!d) return '—';
  return new Date(d).toLocaleDateString('en-KE', {
    day: '2-digit', month: 'short', year: 'numeric',
  });
}